// src/App.js
// Point d'entrée principal. Gère la navigation entre les pages.

import { useState } from 'react';
import { GlobalStyles } from './styles/GlobalStyles';
import { BottomNav }    from './components/BottomNav';
import { Splash }       from './pages/Splash';
import { Accueil }      from './pages/Accueil';
import { Jeux }         from './pages/Jeux';
import { Idees }        from './pages/Idees';
import { Shop }         from './pages/Shop';
import { Plus }         from './pages/Plus';
import { Favoris }      from './pages/Favoris';
import { useFavorites } from './hooks/useFavorites';

export default function App() {
  const [splash,      setSplash]      = useState(true);
  const [tab,         setTab]         = useState('accueil');
  const [showFavoris, setShowFavoris] = useState(false);
  const { favs, toggle } = useFavorites();

  function nav(t) {
    if (t === 'favoris') { setShowFavoris(true); return; }
    setShowFavoris(false);
    setTab(t);
  }

  if (splash) return (
    <>
      <GlobalStyles />
      <Splash onDone={() => setSplash(false)} />
    </>
  );

  return (
    <div style={{ maxWidth: 430, margin: '0 auto', position: 'relative', minHeight: '100vh' }}>
      <GlobalStyles />

      {showFavoris ? (
        <Favoris favs={favs} onFav={toggle} onBack={() => setShowFavoris(false)} />
      ) : (
        <>
          {tab === 'accueil' && <Accueil onNav={nav} favs={favs} onFav={toggle} />}
          {tab === 'jeux'    && <Jeux    favs={favs} onFav={toggle} />}
          {tab === 'idees'   && <Idees   favs={favs} onFav={toggle} />}
          {tab === 'shop'    && <Shop />}
          {tab === 'plus'    && <Plus    favs={favs} onFav={toggle} />}
        </>
      )}

      <BottomNav active={showFavoris ? '' : tab} onNav={nav} />
    </div>
  );
}
